const readingIndicator = document.getElementsByClassName('js-reading-progressbar')[0];
const readingIndicatorContent = document.getElementsByClassName('js-reading-content')[0];

if (readingIndicator && readingIndicatorContent) {
  let progressInfo = [],
    progressEvent = false,
    progressFallback = readingIndicator.getElementsByClassName('js-reading-progressbar__fallback')[0],
    progressIsSupported = 'value' in readingIndicator;

  let boundingClientRect = readingIndicatorContent.getBoundingClientRect();

  progressInfo['height'] = readingIndicatorContent.offsetHeight;
  progressInfo['top'] = boundingClientRect.top;
  progressInfo['bottom'] = boundingClientRect.bottom;
  progressInfo['window'] = window.innerHeight;
  progressInfo['class'] = 'reading-progressbar--is-active';
  progressInfo['hideClass'] = 'reading-progressbar--is-out';

  setProgressIndicator();

  if (document.fonts) {
    document.fonts.ready.then(function () {
      triggerReset();
    });
  }
  window.addEventListener('resize', function (event) {
    triggerReset();
  });

  //listen to the window scroll event - update progress
  window.addEventListener('scroll', function (event) {
    if (progressEvent) return;
    progressEvent = true;
    if(!window.requestAnimationFrame) {
      setTimeout(function () {
        setProgressIndicator();
      }, 250)
    } else {
      window.requestAnimationFrame(setProgressIndicator);
    }
  });

  function setProgressIndicator() {
    const boundingClientRect = readingIndicatorContent.getBoundingClientRect();
    progressInfo['top'] = boundingClientRect.top;
    progressInfo['bottom'] = boundingClientRect.bottom;

    if (progressInfo['height'] <= progressInfo['window']) {
      // short content - hide progress indicator
      removeClass(readingIndicator, progressInfo['class']);
      progressEvent = false;
      return;
    }
    // get new progress and update element
    addClass(readingIndicator, progressInfo['class']);
    let value = (progressInfo['top'] >= 0) ? 0 : 100 * (0 - progressInfo['top']) / (progressInfo['height'] - progressInfo['window']);
    readingIndicator.setAttribute('value', value);
    if (!progressIsSupported && progressFallback) progressFallback.style.width = value + '%';
    // hide progress bar when target is outside the viewport
    toggleClass(readingIndicator, progressInfo['hideClass'], progressInfo['bottom'] <= 0);
    progressEvent = false;
  }

  function triggerReset() {
    if (progressEvent) return;
    progressEvent = true;
    if(!window.requestAnimationFrame) {
      setTimeout(function () {
        resetProgressIndicator();
      }, 250)
    } else {
      window.requestAnimationFrame(resetProgressIndicator);
    }
  }

  function resetProgressIndicator() {
    progressInfo['height'] = readingIndicatorContent.offsetHeight;
    progressInfo['window'] = window.innerHeight;
    setProgressIndicator();
  }

  function addClass(el, className) {
    let classList = className.split(' ');
    el.classList.add(classList[0]);
    if (classList.length > 1) addClass(el, classList.slice(1).join(' '));
  }

  function removeClass(el, className) {
    let classList = className.split(' ');
    el.classList.remove(classList[0]);
    if (classList.length > 1) removeClass(el, classList.slice(1).join(' '));
  }

  function toggleClass(el, className, bool) {
    if(bool) addClass(el, className);
    else removeClass(el, className);
  }
}
